import classNames from 'classnames'
import React from 'react'

import Link from '~/components/link'

import { ButtonProperties } from '../types'
import ClientButton from './client-button'

const BaseButton: React.FC<ButtonProperties> = ({
  component = 'link',
  text,
  textMobile,
  className,
  blank,
  children,
  openContactModal,
  ...rest
}) => {
  if (component === 'link' && !openContactModal) {
    const properties = rest as React.AnchorHTMLAttributes<HTMLAnchorElement>
    return (
      <Link
        className={classNames('link-button ', className)}
        href={properties.href}
        blank={blank}
        {...properties}
      >
        {textMobile ? (
          <>
            <span className="hidden md:inline">{text}</span>
            <span className="md:hidden">{textMobile}</span>
          </>
        ) : (
          <>{text}</>
        )}
        {children}
      </Link>
    )
  }

  return (
    <ClientButton
      text={text}
      textMobile={textMobile}
      className={className}
      openContactModal={openContactModal}
      {...(rest as React.ButtonHTMLAttributes<HTMLButtonElement>)}
    >
      {children}
    </ClientButton>
  )
}

export default BaseButton
